module.exports = __webpack_public_path__ + "img/executive_sinature.95e1e399.png";